import React, { useState } from 'react';
import './unauth-head.styles.scss';
import { Link, useNavigate } from 'react-router-dom';
import logo_long from '@/assets/logo_long.png';
import { useSelector } from 'react-redux';
import UserIcon from '../layout-auth/user-icon/user-icon.component';
import UnauthUserDropdown from './unauth-user-dropdown.component';
import UnuathUserDropdown from './unauth-user-dropdown.component';

const UnauthHeader = () => {

    const currentUser = useSelector(state => state.userData.currentUser);
    const userProfile = useSelector(state => state.userData.userProfile);
    const [ showDropdown, setShowDropdown ] = useState();
    const navigate = useNavigate();

    return (
        <div className='unauth-head-container'>
            {/* <div className="g-container"> */}
                <div className='unauth-head'>
                    <div className='logo-div'>
                        <Link to='/'>
                        <img src={logo_long} />
                        </Link>
                    </div>
                    <div className="links-div">
                        <a href='https://gamably.com/info' className='head-link'>Features</a>
                        <Link to="/pricing" className='head-link'>Pricing</Link>
                        {
                            (currentUser && userProfile) 
                            ?
                            <>
                            {
                                (userProfile.upload && userProfile.gamePath)
                                ?
                                <Link to={`/play/${userProfile.gamePath}`} className='head-link'>My Game</Link>
                                :
                                <Link to="/loading" className='head-link'>My Games</Link>
                            }
                            <button 
                                className='g-button text-only icon-button'
                                onClick={() => setShowDropdown(!showDropdown)} >
                                <UserIcon 
                                    className='clickable' 
                                    profile={userProfile} 
                                    reverse={true} 
                                    planIcon={true}
                                     />
                            </button>
                            </>
                            :
                            <Link to="/signin"><button className='g-button small-btn primary' >Sign In</button></Link>
                        }
                        <UnuathUserDropdown
                            show={showDropdown} />
                    </div>
                </div>
            {/* </div> */}
            
        </div>
    )
}

export default UnauthHeader